import { createFileRoute } from '@tanstack/react-router'

import { ReconciliationPage } from '@/modules/insights/pages'

export const Route = createFileRoute(
  '/_authenticated/projects/$slug/insights/reconciliation',
)({
  component: () => <ReconciliationPage slug={Route.useParams().slug} />,
})
